module.exports = __webpack_public_path__ + "img/public_request_geninfo_mobile_600.425cae52.png";